import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import './HeroSection.css';

const HeroSection = ({ formData, onInputChange, onSubmit }) => {
  const [hasSubmitted, setHasSubmitted] = React.useState(false);

  // Mapeamento de códigos de país para códigos ISO
  const getCountryCode = (phoneCode) => {
    const countryMap = {
      '+55': 'BR',
      '+1': 'US',
      '+351': 'PT',
      '+34': 'ES',
      '+33': 'FR',
      '+49': 'DE',
      '+39': 'IT',
      '+44': 'GB'
    };
    return countryMap[phoneCode] || 'BR';
  };

  const getCountryName = (phoneCode) => {
    const nameMap = {
      '+55': 'Brasil',
      '+1': 'EUA',
      '+351': 'Portugal',
      '+34': 'Espanha',
      '+33': 'França',
      '+49': 'Alemanha',
      '+39': 'Itália',
      '+44': 'Reino Unido'
    };
    return nameMap[phoneCode] || 'Brasil';
  };
  return (
    <section id="hero-section" className="hero-section" aria-label="Seção principal do webinário">
      <div className="hero-content">
        <header className="hero-text-content">
          <h1 className="hero-title">
            Aprenda a única forma REAL de ganhar dinheiro no trade <span className="highlight-text">começando do zero.</span>
          </h1>
          <p className="hero-subtitle">
            De 30/06 a 02/07 você terá aulas ao vivo gratuitas, no Zoom (sem gravação), para aprender como operar EXATAMENTE IGUAL os traders que lucram todos os dias no mercado.
          </p>
          <form
            className="hero-form"
            autoComplete="on"
            onSubmit={(e) => {
              setHasSubmitted(true);
              onSubmit(e);
            }}
          >
            <input
              type="text"
              placeholder="Nome"
              className="form-field"
              name="name"
              autoComplete="name"
              value={formData.nome}
              onChange={(e) => onInputChange('nome', e.target.value)}
              required
            />
            <input
              type="email"
              placeholder="Email"
              className="form-field"
              name="email"
              autoComplete="email"
              value={formData.email}
              onChange={(e) => onInputChange('email', e.target.value)}
              required
            />
            <div className="phone-input-container">
              <div className="country-selector-wrapper">
                <ReactCountryFlag
                  countryCode={getCountryCode(formData.countryCode)}
                  svg
                  style={{
                    width: '24px',
                    height: '18px',
                    marginRight: '8px'
                  }}
                  title={getCountryName(formData.countryCode)}
                />
                <select
                  className="country-select"
                  name="countryCode"
                  autoComplete="tel-country-code"
                  value={formData.countryCode}
                  onChange={(e) => onInputChange('countryCode', e.target.value)}
                >
                  <option value="+55">+55</option>
                  <option value="+1">+1</option>
                  <option value="+351">+351</option>
                  <option value="+34">+34</option>
                  <option value="+33">+33</option>
                  <option value="+49">+49</option>
                  <option value="+39">+39</option>
                  <option value="+44">+44</option>
                </select>
              </div>
              <input
                type="tel"
                placeholder="(11) 99999-9999"
                className={`form-field phone-input ${hasSubmitted && formData.countryCode === '+55' && formData.whatsapp.replace(/\D/g, '').length !== 11 ? 'phone-input-invalid' : ''}`}
                name="tel"
                autoComplete="tel"
                inputMode="tel"
                value={formData.whatsapp}
                onChange={(e) => onInputChange('whatsapp', e.target.value)}
                onInvalid={(e) => {
                  if (formData.countryCode === '+55') {
                    const phoneDigits = formData.whatsapp.replace(/\D/g, '');
                    if (phoneDigits.length !== 11) {
                      e.target.setCustomValidity('Insira um número válido');
                    } else {
                      e.target.setCustomValidity('');
                    }
                  }
                }}
                onInput={(e) => e.target.setCustomValidity('')}
                pattern={formData.countryCode === '+55' ? '\\(?[0-9]{2}\\)?\\s?[0-9]{5}-?[0-9]{4}' : '.*'}
                required
              />
            </div>
            <button type="submit" className="cta-button">
              Vagas Limitadas!
            </button>
          </form>
        </header>
        <div className="hero-image">
          <img
            src="https://cms.sbxtreinamentos.com.br/wp-content/uploads/2025/10/hero-image-2.png"
            alt="Eduardo - Mentor de Trading"
            className="hero-mentor-image"
          />
        </div>
      </div>
      <div className="hero-background">
        <div className="hero-dots-pattern"></div>
        <div className="hero-dots-pattern-secondary"></div>
        <div className="hero-gradient-overlay"></div>
        <div className="hero-diagonal-light"></div>
      </div>
    </section>
  );
};

export default HeroSection;
